// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"156":"f09c7d68","488":"195cdcce","519":"195cdcce","537":"f09c7d68","854":"f09c7d68","893":"79d4df9f","918":"195cdcce"}[chunkId] + ".css";
};